module.exports = __webpack_public_path__ + "60cb1b305a0282f914bbb1334da37156.svg";